import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_URL } from "../../app.config";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { editTournamentApiCall } from "../../Store/slices/touenamentSlice";
import { uploadImageOnAWS } from "../../utils/aws.service";
import {
  convertToBase64,
  TOAST_ERROR,
  TEXT_WITH_NOT_START_SPACE_VALIDATION,
  NUMBER_VALIDATION,
} from "../../utils/common.service";
import * as API from "../../utils/api.service";

export default function EditTournament() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [ranges, setRanges] = useState([
    { from_time: "", to_time: "", points: "" },
    { from_time: "", to_time: "", points: "" },
    { from_time: "", to_time: "", points: "" },
    { from_time: "", to_time: "", points: "" },
    { from_time: "", to_time: "", points: "" },
  ]);
  const clientData = location?.state?.clientData;
  //console.log("client-data------------------------------", clientData);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  const [tournamentImageState, setTournamentImageState] = useState(
    PUBLIC_URL + "/assets/images/default_logo.jpg"
  );
  const [letterImageState, setLetterImageState] = useState(
    PUBLIC_URL + "/assets/images/default_letter.jpg"
  );
  // const [backgroundImageState, setBackgroundImageState] = useState(
  //   PUBLIC_URL + "/assets/images/default_background.jpg"
  // );
  const [isFree, setIsFree] = useState(clientData?.is_free);

  useEffect(() => {
    if (clientData) {
      setTournamentImageState(clientData?.tournament_image);
      setLetterImageState(clientData?.latter_image);
      //setBackgroundImageState(clientData?.background_image);
      reset({
        tournament_image: clientData?.tournament_image_name,
        latter_image: clientData?.letter_name,
        tournament_title: clientData?.tournament_title || "",
        image_title: clientData?.image_title || "",
        ar_tournament_title: clientData?.ar_tournament_title || "",
        ar_image_title: clientData?.ar_image_title || "",
        wining_point: clientData?.wining_point || "",
        skip_point: clientData?.skip_point || "",
        required_point: clientData?.required_point || "",
        start_date: clientData?.start_date || "",
        end_date: clientData?.end_date || "",
        max_participation: clientData?.max_participation || "",
        description: clientData?.description || "",
        ar_description: clientData?.ar_description || "",
        total_used_line: clientData?.total_used_line || "",
      });
    }
  }, [clientData, reset]);

  const handleImageChange = async (image, field) => {
    let imageSize = image.size / 1024;
    if (imageSize > 3072) {
      TOAST_ERROR("Please select an image smaller than 3MB");
    } else {
      setValue(field, image);
      const bufferImage = await convertToBase64(image);
      switch (field) {
        case "tournamentImage":
          setTournamentImageState(bufferImage);
          break;
        case "letterImage":
          setLetterImageState(bufferImage);
          break;
        // case "backgroundImage":
        //   setBackgroundImageState(bufferImage);
        //   break;
        default:
          break;
      }
      clearErrors(field);
    }
  };

  useEffect(() => {
    const fetchRanges = async () => {
      try {
        let request = {
          id: clientData?.id,
        };
        dispatch(setLoader(true));
        const response = await API.getTournamentrangeApi(request);

        if (response?.data) {
          // Ensure there are always 5 ranges
          const fetchedRanges =
            response.data.length >= 5
              ? response.data
              : [
                  ...response.data,
                  ...Array(5 - response.data.length).fill({
                    from_time: "",
                    to_time: "",
                    points: "",
                  }),
                ];
          setRanges(fetchedRanges);
        }

        dispatch(setLoader(false));
      } catch (error) {
        dispatch(setLoader(false));
        TOAST_ERROR("Failed to load ranges");
      }
    };

    fetchRanges();
  }, [clientData?.id, dispatch]);

  // Handle input change in range fields
  const handleChange = (index, field, value) => {
    const updatedRanges = [...ranges];
    updatedRanges[index] = {
      ...updatedRanges[index],
      [field]: value,
    };
    setRanges(updatedRanges);
  };

  // Function to validate a specific range
  // Updated function to use correct keys for range
  const validateRange = (range, previousEnd = null) => {
    const { from_time: start, to_time: end, points } = range;

    if (start === "" || end === "" || points === "") {
      setError("Range fields cannot be empty.");
      return false;
    }

    if (Number(start) >= Number(end)) {
      setError("Range start must be less than the end for all ranges.");
      return false;
    }

    if (previousEnd !== null && Number(start) <= Number(previousEnd)) {
      setError("Range start must be greater than the previous range's end.");
      return false;
    }

    return true;
  };

  // Check and validate the ranges before submission

  const [valid, setValid] = useState(false);
  const [error, setError] = useState("");
  let newValidRanges = [];
  const checkCompletion = () => {
    let previousEnd = null;
    let validRanges = []; // Temp array to store valid ranges

    for (let i = 0; i < ranges.length; i++) {
      // Only validate if at least one field is filled out for that range
      if (ranges[i].from_time || ranges[i].to_time || ranges[i].points) {
        if (validateRange(ranges[i], previousEnd)) {
          validRanges.push(ranges[i]);
          previousEnd = ranges[i].to_time;
        } else {
          setValid(false);
          return false;
        }
      }
    }

    if (validRanges.length > 0) {
      newValidRanges = validRanges; // Assign the validated ranges to the correct variable
      setValid(true);
      setError("");
      return true;
    } else {
      setValid(false);
      setError("Please fill at least one valid range properly.");
      return false;
    }
  };

  const onSubmit = async (submitData) => {
    if (!checkCompletion()) {
      TOAST_ERROR("Please fill the ranges correctly before submitting.");
      return;
    }
    try {
      dispatch(setLoader(true));

      let requestBody = {
        id: clientData?.id,
        tournament_title: submitData?.tournament_title,
        ar_tournament_title: submitData?.ar_tournament_title,
        tournament_image:
          submitData?.tournamentImage || clientData?.tournament_image_name,
        latter_image: submitData?.letterImage || clientData?.letter_name,
        image_title: submitData?.image_title,
        ar_image_title: submitData?.ar_image_title,
        wining_point: submitData?.wining_point,
        skip_point: submitData?.skip_point,
        required_point: submitData?.required_point,
        start_date: submitData?.start_date,
        end_date: submitData?.end_date,
        max_participation: submitData?.max_participation,
        description: submitData?.description,
        ar_description: submitData?.ar_description,
        total_used_line: submitData?.total_used_line,
        ranges: newValidRanges,
        is_free: isFree,
      };

      const imageFieldMapping = {
        tournamentImage: "tournament_image",
        letterImage: "latter_image",
      };

      for (const field of ["tournamentImage", "letterImage"]) {
        let image = submitData[field];
        if (image instanceof Blob) {
          image = await uploadImageOnAWS(image, "tournament");
          requestBody[imageFieldMapping[field]] = image;
        }
      }

      //console.log("requestbody", requestBody);

      await dispatch(editTournamentApiCall(requestBody));
      navigate(`/manage_tournament`);
      reset();
      dispatch(setLoader(false));
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <div className="content">
      <div className="container-fluid">
        <SubNavbar
          title={`Edit Tournament`}
          header={`tournament`}
          subHeader={`Edit Tournament`}
        />
        <div className="card rounded-3">
          <div className="card-body">
            <div className="d-flex justify-content-lg-start">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => navigate(-1)}
              >
                <i className="bi bi-arrow-left"></i>
              </button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3">
                {/* Image Fields */}
                <div className="col-md-6">
                  <Controller
                    name="tournament_image"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <div className="d-flex flex-column align-items-center">
                        <img
                          src={tournamentImageState}
                          alt="tournament image"
                          className="img-fluid img-thumbnail"
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "10%",
                          }}
                        />
                        <label htmlFor="logoImage">
                          <div className="upload-document mt-2">
                            <div className="btn btn-outline-info m-1">
                              Choose Tournament Image
                            </div>
                          </div>
                        </label>
                      </div>
                    )}
                  />
                  <input
                    type="file"
                    name="files[]"
                    id="logoImage"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleImageChange(e.target.files[0], "tournamentImage")
                    }
                    accept="image/*"
                  />
                </div>

                {/* Letter Image */}
                <div className="col-md-6">
                  <Controller
                    name="letterImage"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <div className="d-flex flex-column align-items-center">
                        <img
                          src={letterImageState}
                          alt="letter image"
                          className="img-fluid img-thumbnail"
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "10%",
                          }}
                        />
                        <label htmlFor="letterImage">
                          <div className="upload-document mt-2">
                            <div className="btn btn-outline-info m-1">
                              Choose Letter Image
                            </div>
                          </div>
                        </label>
                      </div>
                    )}
                  />
                  <input
                    type="file"
                    name="files[]"
                    id="letterImage"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleImageChange(e.target.files[0], "letterImage")
                    }
                    accept="image/svg+xml"
                  />
                </div>
              </div>
              {/* Form Fields */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="tournament_title" className="form-label">
                    Tournament Title
                  </label>
                  <input
                    type="text"
                    id="tournament_title"
                    className="form-control"
                    placeholder="Enter Title"
                    {...register(
                      "tournament_title",
                      TEXT_WITH_NOT_START_SPACE_VALIDATION("tournament_title")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                  />

                  <div className="errorc">
                    {errors.tournament_title?.message}
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="image_title" className="form-label">
                    Image Title
                  </label>
                  <input
                    type="text"
                    id="image_title"
                    className="form-control"
                    placeholder="Enter Title"
                    {...register(
                      "image_title",
                      TEXT_WITH_NOT_START_SPACE_VALIDATION("image_title")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">{errors.image_title?.message}</div>
                </div>
              </div>
              {/* arebic title */}
              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="ar_tournament_title" className="form-label">
                    Tournament Title(Arabic)
                  </label>
                  <input
                    type="text"
                    id="ar_tournament_title"
                    className="form-control"
                    placeholder="Enter Title"
                    {...register(
                      "ar_tournament_title",
                      TEXT_WITH_NOT_START_SPACE_VALIDATION(
                        "ar_tournament_title"
                      )
                    )}
                    aria-invalid={errors.ar_tournament_title ? "true" : "false"}
                  />

                  <div className="errorc">
                    {errors.ar_tournament_title?.message}
                  </div>
                </div>

                <div className="col-md-6">
                  <label htmlFor="ar_image_title" className="form-label">
                    Image Title(Arabic)
                  </label>
                  <input
                    type="text"
                    id="ar_image_title"
                    className="form-control"
                    placeholder="Enter Title"
                    {...register(
                      "ar_image_title",
                      TEXT_WITH_NOT_START_SPACE_VALIDATION("ar_image_title")
                    )}
                    aria-invalid={errors.ar_image_title ? "true" : "false"}
                  />
                  <div className="errorc">{errors.ar_image_title?.message}</div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-3">
                  <label htmlFor="wining_point" className="form-label">
                    Winning Point
                  </label>
                  <input
                    type="text"
                    id="wining_point"
                    className="form-control"
                    placeholder="Enter winning points"
                    {...register(
                      "wining_point",
                      NUMBER_VALIDATION("wining point")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">{errors.wining_point?.message}</div>
                </div>

                <div className="col-md-3">
                  <label htmlFor="skip_point" className="form-label">
                    Skip Points
                  </label>
                  <input
                    type="text"
                    id="skip_point"
                    className="form-control"
                    placeholder="Enter skip points"
                    {...register("skip_point", NUMBER_VALIDATION("skip point"))}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">{errors.skip_point?.message}</div>
                </div>

                <div className="col-md-3">
                  <label htmlFor="required_point" className="form-label">
                    Required Points
                  </label>
                  <input
                    type="text"
                    id="required_point"
                    className="form-control"
                    placeholder="Enter required points"
                    {...register(
                      "required_point",
                      NUMBER_VALIDATION("required point")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">{errors.required_point?.message}</div>
                </div>

                <div className="mb-3 col-3">
                  <label className="form-label">Total Line</label>
                  <input
                    type="text"
                    className="form-control"
                    {...register(
                      "total_used_line",
                      NUMBER_VALIDATION("total line")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                    defaultValue={clientData?.total_used_line || ""}
                    placeholder="Enter Total Line"
                  />
                  <div className="errorc">
                    {errors.total_used_line?.message}
                  </div>
                </div>
              </div>
              {/* Date Fields */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <label htmlFor="start_date" className="form-label">
                    Start Date
                  </label>
                  <input
                    type="datetime-local"
                    id="start_date"
                    className="form-control"
                    {...register("start_date", {
                      required: "Start date is required",
                    })}
                  />
                  <div className="errorc">{errors.start_date?.message}</div>
                </div>

                <div className="col-md-4">
                  <label htmlFor="end_date" className="form-label">
                    End Date
                  </label>
                  <input
                    type="datetime-local"
                    id="end_date"
                    className="form-control"
                    {...register("end_date", {
                      required: "End date is required",
                    })}
                  />
                  <div className="errorc">{errors.end_date?.message}</div>
                </div>

                <div className="col-md-4">
                  <label htmlFor="max_participation" className="form-label">
                    Max Participation
                  </label>
                  <input
                    type="text"
                    id="max_participation"
                    className="form-control"
                    placeholder="Enter Max Participation"
                    {...register(
                      "max_participation",
                      NUMBER_VALIDATION("max participation")
                    )}
                    aria-invalid={errors.email ? "true" : "false"}
                  />
                  <div className="errorc">
                    {errors.max_participation?.message}
                  </div>
                </div>
              </div>
              {/* Other Fields */}
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">
                    Description
                  </label>
                  <textarea
                    id="description"
                    className="form-control"
                    rows={3}
                    placeholder="Enter description"
                    {...register("description")}
                  />
                  <div className="errorc">{errors.description?.message}</div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Is Free:</label>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="isFree"
                    checked={isFree === "true"}
                    onChange={(e) =>
                      setIsFree(e.target.checked ? "true" : "false")
                    }
                  />
                  <label className="form-check-label" htmlFor="isFree">
                    {isFree === "true" ? "Active" : "Inactive"}
                  </label>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="ar_description" className="form-label">
                    Description(Arabic)
                  </label>
                  <textarea
                    id="ar_description"
                    className="form-control"
                    rows={3}
                    placeholder="Enter description"
                    {...register("ar_description")}
                  />
                  <div className="errorc">{errors.ar_description?.message}</div>
                </div>
              </div>
              <h3>Enter Ranges(In Seconds)</h3>
              {ranges.map((range, index) => (
                <div key={index} className="row mb-3">
                  <div className="col-md-4">
                    <input
                      type="number"
                      placeholder={`Range ${index + 1} Start Time In Seconds`}
                      className="form-control"
                      value={range.from_time || ""}
                      onChange={(e) =>
                        handleChange(index, "from_time", e.target.value)
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      placeholder={`Range ${index + 1} End Time In Seconds`}
                      className="form-control"
                      value={range.to_time || ""}
                      onChange={(e) =>
                        handleChange(index, "to_time", e.target.value)
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <input
                      type="number"
                      placeholder={`Range ${index + 1} Points`}
                      className="form-control"
                      value={range.points || ""}
                      onChange={(e) =>
                        handleChange(index, "points", e.target.value)
                      }
                    />
                  </div>
                </div>
              ))}
              {error && <p style={{ color: "red" }}>{error}</p>}
              <div className="d-flex justify-content-center mt-3">
                <button className="btn btn-primary m-1" type="submit">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
